/**
 * Runtime config — one bundle runs on dev and prod.
 *
 * The deploy writes /config.js per environment (window.__BROKLY_CONFIG__), loaded
 * by each HTML entry before the app. Local dev and vitest have no values there, so
 * every key falls back to the Vite env (.env.local, vi.stubEnv).
 */

export type RuntimeConfigKey =
  | 'VITE_API_BASE_URL'
  | 'VITE_DATA_MODE'
  | 'VITE_OIDC_AUTHORITY'
  | 'VITE_OIDC_CLIENT_ID'
  | 'VITE_ADMIN_OIDC_URL'
  | 'VITE_ADMIN_OIDC_REALM'
  | 'VITE_ADMIN_OIDC_CLIENT_ID'
  | 'BROKLY_VERSION';

declare global {
  interface Window {
    __BROKLY_CONFIG__?: Partial<Record<RuntimeConfigKey, string>>;
  }
}

export function runtimeConfig(key: RuntimeConfigKey): string | undefined {
  return window.__BROKLY_CONFIG__?.[key] ?? (import.meta.env[key] as string | undefined);
}
